import { ItzehoerLogo } from "@App/Components/atoms/whitelabel/logos/ItzehoerLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Itzehoer whitelabel.
 * Extends the default configuration with specific settings for Itzehoer.
 */
export const config: Partial<Config> = {
  slug: "itzehoer",
  navbar: {
    logos: {
      right: {
        component: <ItzehoerLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.itzehoer.de/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
